import { render, staticRenderFns } from "./PatientEmergencyInfo.vue?vue&type=template&id=693c337c"
import script from "./PatientEmergencyInfo.vue?vue&type=script&lang=js"
export * from "./PatientEmergencyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports